import React, {useRef, useState} from "react";
import file from "../../image/file/file.png"
import {Alert, Button, Divider, Tooltip, Upload} from "antd";
import {ZKY_URL_DISTRI_GOODS_UPLOAD} from "../../../public/variables";
import Message from "../../../common/message";
import ZkModal from "../../../common/modal/zkModal";
import zip from '../../image/file/zip.png'
import txt from "../../image/file/txt.png";
import ppt from "../../image/file/ppt.png";
import word from "../../image/file/word.png";
import excel from "../../image/file/excel.png";
import pdf from "../../image/file/pdf.png";
import unknownFile from "../../image/messageList/unknownFile.png";
import Util from "../../../public/utils";
import Vars from "../../../cmpts/system_vars";

let imUploadFileResolve;
let imUploadFileReject;
const ImFile = (props) => {
    const {chatData} = props
    const [data, setData] = useState({})
    const [loading, setLoading] = useState(false)
    const okModalRef = useRef()
    const uploadProps = {
        accept: 'file',
        name: 'uploadfile',
        action: ZKY_URL_DISTRI_GOODS_UPLOAD,
        headers: {},
        beforeUpload(file, fileList) {
            setData(file)
            okModalRef.current.show()
            return new Promise((resolve, reject) => {
                //确定 = resolve,执行上传  取消 = reject,不上传
                imUploadFileResolve = resolve;
                imUploadFileReject = reject;
            })
        },
        onChange(info) {
            if (info.file.status == 'uploading') {
                // console.log('9898',info.file, info.fileList);
                setLoading(true)
            }
            if (info.file.status === 'done') {
                setLoading(false)
                okModalRef.current.hide()
                props.getFile(info.file)
            } else if (info.file.status === 'error') {
                setLoading(false)
                // Message.error(`${info.file.name} 上传失败`);
            }
        },
    };

    function fileImg(fileName) {
        if (fileName.indexOf('txt') != -1) {
            return txt
        } else if (fileName.indexOf('ppt') != -1) {
            return ppt
        } else if (fileName.indexOf('doc') != -1) {
            return word
        } else if (fileName.indexOf('xlsx') != -1 || fileName.indexOf('xls') != -1 || fileName.indexOf('csv') != -1) {
            return excel
        } else if (fileName.indexOf('pdf') != -1) {
            return pdf
        } else if (fileName.indexOf('zip') != -1 || fileName.indexOf('rar') != -1 || fileName.indexOf('7z') != -1 || fileName.indexOf(' gzip') != -1 || fileName.indexOf(' tar.gz') != -1) {
            return zip
        } else if (fileName.indexOf('video') != -1) {
            return 'video'
        } else if (fileName.indexOf('image') != -1) {
            return 'image'
        } else {
            return unknownFile
        }
    }

    function getObjectURL(file) {
        let url = null
        if (window.createObjectURL != undefined) {
            url = window.createObjectURL(file)
        } else if (window.URL != undefined) {
            url = window.URL.createObjectURL(file)
        } else if (window.webkitURL != undefined) {
            url = window.webkitURL.createObjectURL(file)
        }
        return url
    }

    //文件是否能发送
    function isFileSend() {
        if (JSON.stringify(data) != '{}' && data.size == 0) {
            return true
        } else if (JSON.stringify(data) != '{}' && data.size > Vars.FILE_MAXSIZE()) {
            return true
        }
        return false
    }

    return (
        <>
            <Tooltip placement="top" title={'文件'}>
                <Upload {...uploadProps} className={'im-picture-upload'}>
                    <img src={file} className={'im-file'} onClick={null}/>
                </Upload>
            </Tooltip>

            {/*{确认发送modal}*/}
            <ZkModal title={'发送给：'} ref={okModalRef} width={480}
                     footer={[
                         <Button onClick={() => {
                             imUploadFileReject(), okModalRef.current.hide()
                         }}>取消
                         </Button>,
                         <Button loading={loading} type="primary"
                                 onClick={() => imUploadFileResolve(data)}
                                 disabled={isFileSend()}
                         >
                             确定
                         </Button>,
                     ]}
                     maskClosable={false} className={'modal-right-btn im-setting-modal'}
                     afterClose={null}
                     destroyOnClose
            >
                {/*{发送者信息}*/}
                <div className={'im-file-sender'}>
                    {
                        chatData.isRoom == 1 ?
                            <>
                                <img src={chatData.avatar}/>
                                <span>{chatData.name}</span>
                            </>
                            :
                            <>
                                <img src={chatData.avatar}/>
                                <span>{chatData.name}</span>
                                <span className={chatData.corpShortName == '微信' ? 'title-wxName' : 'title-corpName'}>
                                        {chatData.corpShortName ? `@${chatData.corpShortName}` : ''}
                                    </span>
                            </>
                    }
                </div>
                <Divider className={'im-file-divider'}/>

                {/*{发送内容}*/}
                {
                    JSON.stringify(data) != '{}' ?
                        <div className={'im-file-content'}>
                            {
                                fileImg(data.type) == 'video' ?
                                    <video className={'im-file-video'}>
                                        <source
                                            src={getObjectURL(data)}
                                            type="video/mp4"/>
                                        {/*<source src={item.msgData} type="video/ogg" />*/}
                                        您的浏览器不支持 视频。
                                    </video>
                                    :
                                    fileImg(data.type) == 'image' ?
                                        <img src={getObjectURL(data)}/> : <img src={fileImg(data.name)}/>
                            }
                            <div className={'im-file-right'}>
                                <span>{data.name}</span>
                                <span>{Util.fileSizeToString(data.size)}</span>
                            </div>
                        </div> : ''
                }

                {/*{空文件 或 超出大小的警告}*/}
                {
                    JSON.stringify(data) != '{}' && data.size == 0 ?
                        <Alert message="无法发送空文件" type="error" showIcon className={'im-file-warning'}/> :
                        JSON.stringify(data) != '{}' && data.size > Vars.FILE_MAXSIZE() ?
                            <Alert message="文件大小超过50M，无法发送" type="error" showIcon className={'im-file-warning'}/> : ''
                }
            </ZkModal>
        </>
    )
}

export default ImFile